import {
  FETCH_STUDENT_DOCUMENTS_SUCCESS,
  UPLOAD_STUDENT_DOCUMENT_SUCCESS,
  REMOVE_STUDENT_DOCUMENT_SUCCESS,
} from '../actions/actions'

import {
  FETCH_STUDENT_BADGES_REQUEST,
  FETCH_STUDENT_BADGES_SUCCESS,
  FETCH_STUDENT_BADGES_FAILURE,
} from '../actions/actions'

import dotProp from 'dot-prop-immutable-chain'

export default function student(state = {}, action) {
  switch (action.type) {
    case FETCH_STUDENT_DOCUMENTS_SUCCESS:
      return dotProp(state)
        .set('documents', action.documents)
        .value()

    case UPLOAD_STUDENT_DOCUMENT_SUCCESS:
      const addedId = action.document.id
      return dotProp(state)
        .set(`documents.entities.documents.${addedId}`, action.document)
        .set(`documents.result`, documentsList => [...documentsList, addedId])
        .value()

    case REMOVE_STUDENT_DOCUMENT_SUCCESS:
      const removedId = action.documentId
      const filterer = documentsList => documentsList.filter(docId => docId !== removedId)

      return dotProp(state)
        .delete(`documents.entities.${removedId}`)
        .set(`documents.result`, filterer)
        .value()


    case FETCH_STUDENT_BADGES_REQUEST:
      return { ...state, badges: { isLoading: true } }

    case FETCH_STUDENT_BADGES_SUCCESS:
      return { ...state, badges: { badges: action.badges, isLoading: false } }

    case FETCH_STUDENT_BADGES_FAILURE:
      return { ...state, badges: { error: action.error, isLoading: false } }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/student.js